<template>
  <VWidget
    :title="$t('Target conditions')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-spacer/>
      <v-btn
        small
        @click="addTarget"
      >
        {{ $t('Add target') }}
      </v-btn>
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-icon
            class="pointer"
            color="primary"
            dark
            v-on="on"
          >
            info
          </v-icon>
        </template>
        <span v-html="$t('Target condition determines on what <br> kind of products the campaign affects')"/>
      </v-tooltip>
    </div>
    <div
      v-if="item.target_condition && typeof item.target_condition === 'object'"
      slot="widget-content">
      <v-flex
        v-for="(condition, target) in item.target_condition"
        :key="`index-${target}`"
      >
        <DiscountTargetConditionSingle
          :types="types"
          :condition="condition"
          :target="target"
          @removeTarget="removeTarget"
          @replaceTarget="replaceTarget"
          @setValues="setValues"
        />
        <v-divider class="my-3" />
      </v-flex>
    </div>
  </VWidget>
</template>

<script>
import DiscountTargetConditionSingle from './DiscountTargetConditionSingle'

export default {
  name: 'DiscountTargetConditions',

  components: {
    DiscountTargetConditionSingle
  },

  props: {
    item: {
      type: Object,
      default: null
    }
  },

  computed: {
    types () {
      return [
        { key: 'sku', name: 'SKU', exists: this.hasType('sku') },
        { key: 'type', name: 'Type', exists: this.hasType('type') },
        { key: 'name', name: 'Name', exists: this.hasType('name') },
        { key: 'brand', name: 'Brand', exists: this.hasType('brand') },
        { key: 'taxonomy', name: 'Taxonomy', exists: this.hasType('taxonomy') }
      ]
    },

    availableTypes () {
      return this.types.filter(t => !t.exists)
    }
  },

  methods: {
    setValues (key, included, values) {
      const includedValue = included ? 'in' : 'not_in'
      this.$set(this.item.target_condition, key, { [includedValue]: values })
      this.item.isChanged = true
    },

    hasType (type) {
      return (this.item.target_condition || {}).hasOwnProperty(type)
    },

    addTarget () {
      const type = this.availableTypes[0]

      if (!type) {
        return
      }

      if (!this.item.target_condition || Array.isArray(this.item.target_condition)) {
        this.item.target_condition = {}
      }

      this.$set(this.item.target_condition, type.key, { in: [] })
      this.item.isChanged = true
    },

    removeTarget (type) {
      this.$delete(this.item.target_condition, type)
      if (Object.keys(this.item.target_condition).length === 0) {
        this.item.target_condition = null
      }
      this.item.isChanged = true
    },

    replaceTarget (oldTarget, newTarget) {
      this.$delete(this.item.target_condition, oldTarget)
      this.$set(this.item.target_condition, newTarget, { in: [] })
      this.item.isChanged = true
    }
  }
}
</script>

<style scoped>
.v-card__text .flex:last-child .v-divider {
  display: none;
}
</style>
